// Libraries
import {
  Component,
  Input
} from '@angular/core';

// Models
import {
  Position,
  POSITION_STATUSES
} from '../models';

/**
 * `PositionStatusComponent` implements a view to show the status of a position.
 */
@Component({
  selector: 'she-position-status',
  template: `<span class="she-status she-status-{{position?.status}}">{{getResult()}}</span>`
})
export class PositionStatusComponent {
  /**
   * Current position.
   */
  @Input() position: Position;

  /**
   * Creates a new `PositionStatusComponent` instance.
   */
  constructor() {}

  /**
   * Returns the result of position status.
   * @return Status result
   */
  public getResult(): string {
    return this.position ? POSITION_STATUSES[this.position.status] : '';
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/shared/components/position-status.component.ts